import { db } from './firebase';
import { doc, getDoc, getDocs, collection, query, where, runTransaction } from 'firebase/firestore';
import { User } from '../types/auth';

export const dbService = {
  getUserById: async (userId: string) => {
    try {
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);
      
      if (!userDoc.exists()) {
        throw new Error('User not found');
      }

      return {
        id: userDoc.id,
        ...userDoc.data(),
        balance: userDoc.data()?.balance || 0,
        verificationStatus: userDoc.data()?.verificationStatus || 'unverified'
      } as User;
    } catch (error) {
      console.error('Get user error:', error);
      throw error;
    }
  },

  getAllUsers: async () => {
    try {
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('isAdmin', '==', false));
      const snapshot = await getDocs(q);
      
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        balance: doc.data()?.balance || 0,
        verificationStatus: doc.data()?.verificationStatus || 'unverified'
      })) as User[];
    } catch (error) {
      console.error('Get all users error:', error);
      throw error;
    }
  },

  updateUser: async (userId: string, data: Partial<User>) => {
    try {
      await runTransaction(db, async (transaction) => {
        const userRef = doc(db, 'users', userId);
        const userDoc = await transaction.get(userRef);
        
        if (!userDoc.exists()) {
          throw new Error('User not found');
        }

        transaction.update(userRef, data);
      });

      // Get updated user data
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (!userDoc.exists()) {
        throw new Error('User not found after update');
      }

      return {
        id: userDoc.id,
        ...userDoc.data(),
        balance: userDoc.data()?.balance || 0,
        verificationStatus: userDoc.data()?.verificationStatus || 'unverified'
      } as User;
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  },

  createSupportMessage: async (message: any) => {
    try {
      const messagesRef = collection(db, 'support_messages');
      await addDoc(messagesRef, {
        ...message,
        createdAt: new Date(),
        status: 'new'
      });
    } catch (error) {
      console.error('Create support message error:', error);
      throw error;
    }
  }
};